import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackGooglePageView } from "../helpers/googleAnalytics";

export default function GoogleAnalytics() {
  const location = useLocation();
  useEffect(() => { trackGooglePageView(location.key); }, [location.key]);
  return null;
}
